import React, { createContext, useContext, useEffect, useState } from 'react';

const DeliveryModeContext = createContext(null);

const DELIVERY_MODE_STORAGE_KEY = 'yabatho_delivery_mode';

export const DeliveryModeProvider = ({ children }) => {
  const [mode, setMode] = useState('Delivery');

  useEffect(() => {
    const savedMode = localStorage.getItem(DELIVERY_MODE_STORAGE_KEY);

    if (savedMode) {
      setMode(savedMode);
    }
  }, []);

  const changeMode = (newMode) => {
    setMode(newMode);
    localStorage.setItem(DELIVERY_MODE_STORAGE_KEY, newMode);
  };

  return (
    <DeliveryModeContext.Provider value={{ mode, changeMode }}>
      {children}
    </DeliveryModeContext.Provider>
  );
};

export const useDeliveryMode = () => {
  const context = useContext(DeliveryModeContext);

  if (!context) {
    throw new Error('useDeliveryMode must be used inside DeliveryModeProvider');
  }

  return context;
};
